import { render, staticRenderFns } from "./NeuroAcuteCareSummary.vue?vue&type=template&id=9c613a0a&scoped=true&"
import script from "./NeuroAcuteCareSummary.vue?vue&type=script&lang=ts&"
export * from "./NeuroAcuteCareSummary.vue?vue&type=script&lang=ts&"
import style0 from "./NeuroAcuteCareSummary.vue?vue&type=style&index=0&id=9c613a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c613a0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c613a0a')) {
      api.createRecord('9c613a0a', component.options)
    } else {
      api.reload('9c613a0a', component.options)
    }
    module.hot.accept("./NeuroAcuteCareSummary.vue?vue&type=template&id=9c613a0a&scoped=true&", function () {
      api.rerender('9c613a0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/NeuroAcuteCareSummary.vue"
export default component.exports